import React from 'react';
import { useField } from 'formik';

import Summernote from './Summernote.jsx';

const FieldSummernote = (props) => {
  const [, { value }, { setTouched, setValue }] = useField(props);

  return (
    <Summernote
      value={value}
      onBlur={setTouched}
      onChange={setValue}
      {...props}
    />
  );
};

export default FieldSummernote;
